import { useEffect, useState, useRef, useContext } from "react";
import CameraMarker from "pages/dashboard/cameraMap/mark";
import { useMap } from "@vis.gl/react-google-maps";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Mark from "ui/map/mark";
import type { Marker } from "@googlemaps/markerclusterer";
import { StreamingContext } from "context/StreamingContext";
import React from "react";
type Poi = { key: string; location: google.maps.LatLngLiteral; type: string };
const PoiMarkers = (props: {
  pois: Poi[];
  hideCluster?: boolean;
  onClickAlert?: (poi) => void;
}) => {
  console.log("PoiMarkers:", props);
  const map = useMap();
  const [markers, setMarkers] = useState<{ [key: string]: Marker }>({});
  const markersRef = useRef(null);
  const clusterer = useRef<MarkerClusterer | null>(null);
  const { streamingCameras } = useContext(StreamingContext);
  // Initialize MarkerClusterer, if the map has changed
  useEffect(() => {
    if (!map) return;
    if (!clusterer.current) {
      clusterer.current = new MarkerClusterer({
        map,
        algorithmOptions: { maxZoom: 20 },
      });
    }
    map.addListener("zoom_changed", () => {
      const zoom = map.getZoom();
      Object.values(markersRef.current || {}).forEach((marker: any) => {
        if (marker.title.indexOf("camera_") !== -1) {
          marker.map = zoom < 16 ? null : map;
        }
      });
    });
  }, [map]);
  useEffect(() => {
    if (!streamingCameras?.length) return;
    // find the last streaming camera and center the map
    const lastCamera = streamingCameras[streamingCameras.length - 1];
    const matchMarker: any = Object.values(markersRef.current || {}).find(
      (item: any) => item.title === "camera_" + lastCamera.cameraId.toString(),
    );
    matchMarker &&
      map.panTo(
        new google.maps.LatLng(
          matchMarker.position.lat,
          matchMarker.position.lng,
        ),
      );
    map.setZoom(19);
  }, [streamingCameras]);
  // Update markers, if the markers array has changed
  useEffect(() => {
    markersRef.current = markers;
    console.log("updating markers:", markers, Object.values(markers));
    // add only site marker into cluster
    clusterer.current?.clearMarkers();
    const _markerList = Object.values(markers).filter(
      (marker: any) => marker.title.indexOf("camera_") === -1,
    );
    clusterer.current?.addMarkers(_markerList);
    clusterer.current?.render();
  }, [markers]);

  const setMarkerRef = React.useCallback(
    (marker: Marker | null, key: string) => {
      if (props?.hideCluster) {
        return;
      }
      setMarkers((prev) => {
        if (marker && prev[key]) return prev;
        if (!marker && !prev[key]) return prev;
        if (marker) {
          return { ...prev, [key]: marker };
        } else {
          const newMarkers = { ...prev };
          delete newMarkers[key];
          return newMarkers;
        }
      });
    },
    [],
  );

  return (
    <>
      {props?.pois?.map((poi: Poi) => {
        if (poi.type === "camera") {
          const matchCamera = streamingCameras.find(
            (item) => item.cameraId.toString() === poi.key,
          );
          return (
            <CameraMarker
              highLighted={!!matchCamera}
              poi={poi}
              setMarkerRef={setMarkerRef}
              key={poi.key}
              readOnly={true}
            />
          );
        } else {
          return (
            <Mark
              poi={poi}
              setMarkerRef={setMarkerRef}
              key={poi.key}
              onClickAlert={props.onClickAlert}
            />
          );
        }
      })}
    </>
  );
};

export default PoiMarkers;
